var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "project-images-galerys" },
    [
      _vm.data.width > 959
        ? _c("project-gallery-destop", {
            attrs: { images: _vm.images, visible: true },
            on: { showModalGallery: _vm.onShowModalGallery },
          })
        : _vm._e(),
      _vm.data.width <= 959
        ? _c("mobile-gallery", {
            attrs: { images: _vm.images, visible: true },
            on: { showModalGallery: _vm.onShowModalGallery },
          })
        : _vm._e(),
      _c("modal-gallery", {
        attrs: {
          images: _vm.images,
          visible: _vm.data.visible,
          index: _vm.data.index,
        },
        on: { settingVisible: _vm.onSettingVisible },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }